import { dropsHttpClient } from "api/drops/dropsHttpClient";
import { AxiosResponse } from "axios";

const fetchPhoneNumberType = (
  phoneNumber: string,
): Promise<AxiosResponse<{ phoneNumberType: "FUNCTIONAL" | "GSMR" }>> =>
  dropsHttpClient.get(`/crew/phoneNumberType?phoneNumber=${phoneNumber}`);

export type TrainStaffCallerResponse = {
  callerData: TrainStaffCaller | null;
};

export type TrainStaffCaller = {
  trainNumber: string;
  trainDate: string;
  functionRole: string;
  functionalTelephoneNumber: string;
  gsmrNumber: string;
};

const fetchTrainStaffCaller = (
  phoneNumber: string,
): Promise<AxiosResponse<TrainStaffCallerResponse>> =>
  dropsHttpClient.get(`/crew/trainStaffByCaller?phoneNumber=${phoneNumber}`);

export { fetchPhoneNumberType, fetchTrainStaffCaller };
